import { v4 as uuidV4 } from 'uuid'

// Set of keys to ignore during logging
export const ignoredKeys = new Set([
  'xlarge',
  'xxlarge',
  'large',
  'thumbnail',
  'backgroundimage',
  'colorpalette',
])

// Helper function to check if a value should be ignored
export const shouldIgnoreValue = (key, value, ignoreNullValue) => {
  if (typeof value === 'function') return true
  if (ignoreNullValue && (value === null || value === undefined)) return true
  if (key.startsWith('_') || key.startsWith('$')) return true
  if (typeof value === 'string' && value.length > 300) return true
  if (ignoredKeys.has(key.toLowerCase())) return true
  return false
}

// Helper function to check if an object is a Vue component
export const isVueComponent = (value) => {
  return value._isVue || value.$options || value.$el ||
    (value.constructor && (value.constructor.name === 'VueComponent' || value.constructor.name === 'Vue'))
}

const EMAIL_REGEX = /[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}/g

const maskEmail = (email) => {
  return email.replace(/^(.)(.*)(.@.*)$/, (_, first, middle, last) => {
    return `${first}${'*'.repeat(middle.length)}${last}`
  })
}

export function jsonStringify(obj, ignoreNullValue = true) {
  const seen = new WeakSet()

  return JSON.stringify(obj, (key, value) => {
    if (shouldIgnoreValue(key, value, ignoreNullValue)) {
      return undefined
    }

    if (typeof value === 'string') {
      return value.replace(EMAIL_REGEX, (match) => maskEmail(match))
    }

    if (typeof value === 'object' && value !== null) {
      if (isVueComponent(value) || seen.has(value)) {
        return undefined
      }

      seen.add(value)
    }
    return value
  })
}

export const getDeviceId = () => {
  let deviceId = localStorage.getItem('aha-device-id')
  if (!deviceId) {
    deviceId = uuidV4()
    localStorage.setItem('aha-device-id', deviceId)
  }
  return deviceId
}
